import type { ReactNode } from "react";
import type { SmartEditComponentData } from "~/app/api/pageData";
import { useIsSmartEdit } from "~/app/config/pageMetadataContext";

const SLOT_CLASS = "smartEditComponent yCmsContentSlot";
const COMPONENT_CLASS = "smartEditComponent yCmsComponent";

/**
 * Wraps a CMS slot or component in a stable element carrying the SmartEdit
 * data attributes (ADR 0006) — but only while rendering inside SmartEdit AND
 * when the DTO carries `smartEdit`. Outside SmartEdit this renders its
 * children unchanged (no wrapper, no attributes), keeping normal storefront
 * markup byte-identical.
 */
export function SmartEditWrapper({
  kind,
  smartEdit,
  children,
}: {
  kind: "slot" | "component";
  smartEdit?: SmartEditComponentData | null;
  children: ReactNode;
}) {
  const inSmartEdit = useIsSmartEdit();

  if (!inSmartEdit || !smartEdit) {
    return <>{children}</>;
  }

  return (
    <div
      className={kind === "slot" ? SLOT_CLASS : COMPONENT_CLASS}
      data-smartedit-component-id={smartEdit.componentId}
      data-smartedit-catalog-version-uuid={smartEdit.catalogVersionUuid}
      data-smartedit-component-type={smartEdit.componentType}
      data-smartedit-component-uuid={smartEdit.componentUuid}
      data-smartedit-element-uuid={smartEdit.elementUuid}
    >
      {children}
    </div>
  );
}
